 
import WebOffice from '../../../webOffice/index'; 

export default{
    components: {//自定义组件列表 
        'web-office':WebOffice
	},
    data() {
        return {
            breadcrumb:[{
                name:'首页', path:'/home'
            },{
                name:'议题申请列表', path:'/oa/meeting/motion'
            },{
                name:'议题申请详情', path:''
            }],
            apis:{//接口列表 
                upload: this.$global.baseUrl + 'sh/file/upload',//文件上传   
                save:'oa/motion/save',//保存
                bykey:'oa/motion/byKey',//详情 
            }, 
            editObj:{
                title:"",
                fileKey:"", 
            },
            wfFlowModel:{
                finish:false,
                turn:false,
            },
            key:"",
            fileList:[],//源文件  
            fileLists:[],
            
            fileNumList:[],
            webShow:false,
            drawer:false,
            docFileKey: '',
            fileType: ".docx",
        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        bizKey: String,
    },
    watch: {
        bizKey() {
            this.find();
        }, 
    }, 
    mounted() {  
        this.find(); 
    },                           
    methods: {
        find(){
            const me = this;
            me.key = me.bizKey;
            me.$post({
                url: me.apis.bykey,
                params: me.key
            }).then(rsp => {
                if(rsp.success){
                    me.editObj = rsp.retObj;
                    me.fileLists = rsp.retObj.officialFiles;
                    me.$delete(me.editObj, 'officialFiles');
                }
            })
        },
        handlePreview(file) {
            if (file.kindType == 1) {
                this.$emit('changeBiz',file.docKey,1); 
            } else if (file.kindType == 2) {
                this.$emit('changeBiz',file.docKey,2);
            } else if (file.kindType == 3) {
                this.$emit('changeBiz',file.docKey,3);
            } else if (file.kindType == 4) {
                this.$emit('changeBiz',file.docKey,4);
            } else {
                if (file.filePath.includes(".docx") || file.filePath.includes(".xlsx") || file.filePath.includes(".doc") || file.filePath.includes(".xls")) {
                    // this.isView = 1;
                    // this.docFileKey = file.fileKey;
                    // this.fileType = file.filePath.substring(file.filePath.lastIndexOf("."), file.filePath.length);
                    // this.webShow = true;

                    let {href}  = this.$router.resolve({ 
                        path: "/oa/office/browerDialog",
                        query:{
                            isView:1,
                            bizKey:this.key,
                            fileType:file.filePath.substring(file.filePath.lastIndexOf("."), file.filePath.length),
                            bizType:12,
                            fileId:file.fileKey 
                        }
                    })    
                    this.winDialog=window.open(href,"_blank"," left=0,top=0,width="+ (screen.availWidth - 10) +",height="+ (screen.availHeight-50) +",toolbar=no, menubar=no, scrollbars=no,location=no, status=no");
               
                    
                }else if(file.filePath.includes(".txt") ||file.filePath.includes(".pdf") || file.filePath.includes(".PDF") || file.filePath.includes(".png") || file.filePath.includes(".PNG")|| file.filePath.includes(".jgp") || file.filePath.includes(".JPG")|| file.filePath.includes(".gif") || file.filePath.includes(".GIF")){
                    const url = this.$global.baseUrl + file.filePath;
                    window.open(url, '_blank');
                } 
                else {
                    const url = this.$global.baseUrl + 'sh/file/download?id=' + file.fileKey;
                    window.open(url, '_blank');
                }
            } 
        },
       
        goBack(){ 
            this.$router.go(-1);
        },   
        editDoc(){
            // this.docFileKey = this.editObj.fileKey;
            // this.fileType = ".docx";
            // this.webShow = true;

            let {href}  = this.$router.resolve({ 
                path: "/oa/office/browerDialog",
                query:{
                    isView:1,
                    bizKey:this.key,
                    fileType:".docx",
                    bizType:12,
                    fileId:this.editObj.fileKey 
                }
            })    
            this.winDialog=window.open(href,"_blank"," left=0,top=0,width="+ (screen.availWidth - 10) +",height="+ (screen.availHeight-50) +",toolbar=no, menubar=no, scrollbars=no,location=no, status=no");
        
        },
        downloadFile(row){
            if(row.fileKey){
                const url = this.$global.baseUrl + 'sh/file/download?id=' + row.fileKey;
                window.open(url, '_blank');
            }else{
                this.$message.error("该公文未编辑文件,请检查!");
                return;
            }
        },
        downloadAll(){
            const url = this.$global.baseUrl +"oa/official/downloadFileAll?bizKey=" + this.key;
            window.open(url, '_blank');
           
        },
        callback(){

        }
    },
}


// WEBPACK FOOTER //
// ./src/components/oa/view/meeting/motion/view/view.js